















import { Vue, Component, Watch } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
const reimbursement = namespace('reimbursement')
import ImmediatPayment from './components/immediatPayment.vue'
import Prepayment from './components/prepayment.vue'
import { setStore, getStore } from '@/utils/utils'
@Component({
  name: 'paymentConfirm',
  components: {
    ImmediatPayment,
    Prepayment
  }
})
export default class PaymentConfirm extends Vue {
  @reimbursement.Action getTotalAMtShow: any
  @reimbursement.State totalAMtShow: any
  componentData: any = {}
  imComponentData: any = {} // 立即还款
  created() {
    let params = {
      custId: getStore('userInfo') ? JSON.parse(getStore('userInfo')).custId : '', //用户id
      loanAmt: this.$route.query.loanAmt // 金额
    }
    // 提前还款 +全部结清
    let pra = {
      billNo: this.$route.query.billNo, //账单号
      //   loanAmt: this.$route.query.loanAmt, // 金额
      //   reduAmt: this.$route.query.reduAmt, // 减免金额
      billMonth: this.$route.query.billMonth
    }
    // 立即还款
    let imPra = {
      billNo: this.$route.query.billNo,
      loanAmt: this.$route.query.loanAmt, // 金额
      //   reduAmt: this.$route.query.reduAmt, // 减免金额
      billMonth: this.$route.query.billMonth,
      sminAmt: this.$route.query.sminAmt, // 应还最小
      rminAmt: this.$route.query.rminAmt, // 实还最小
      accStat: this.$route.query.accStat, // 判断 是否逾期
      feeRate: this.$route.query.feeRate, // 最低额还款日利率
      minFlag: this.$route.query.minFlag // 判断是否可进行最小额还款
    }
    this.componentData = pra
    this.imComponentData = imPra
    // this.getTotalAMtShow(params) // 还款信息
  }
}
